import React from "react";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";

export const IdentityCard = () => {
  const { user } = useAuth();
  return (
    <div className="border border-[#262626] p-6" data-testid="identity-card">
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-3">Identity</div>
      <div className="text-sm text-zinc-300">{user?.email}</div>
      <div className="text-xs text-zinc-500 mt-1">
        User ID <span className="font-mono">{user?.user_id}</span>
      </div>
    </div>
  );
};

export const NonCustodialCard = () => (
  <div className="border border-[#262626] p-6" data-testid="non-custodial-card">
    <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-3">Custody</div>
    <p className="text-[11px] text-zinc-500 leading-relaxed mb-3">
      Quill is non-custodial — funds flow straight from your client to your wallet,
      so you don't need to hand us any KYC documents to get paid.
    </p>
    <div className="flex items-center gap-2 text-sm">
      <ShieldCheck size={16} className="text-emerald-400" />
      <span>Non-custodial · no KYC required</span>
    </div>
  </div>
);
